import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";

export default function DebugPage() {
  const mailboxes = [
    { name: "Jagmit 👳🏽‍♂️", vanityLink: "js" },
    { name: "Apoorv 🧑🏽", vanityLink: "as" },
  ];

  const teams = [
    { name: "Developer", vanityLink: "dev" },
    { name: "Sales", vanityLink: "sales" },
  ];

  function handleOpenTransfer(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);
    const formJson = Object.fromEntries(formData.entries());
    console.log(formJson);

    window.open("/transfer/get/" + formJson.transferId, "_blank");
  }

  function handleOpenDriveFileViewer(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);
    const formJson = Object.fromEntries(formData.entries());
    const shareLinkUid = String(formJson.shareLinkUid ?? "").trim();

    window.open("/share/files/" + shareLinkUid, "_blank");
  }

  function handleOpenPublishedSpace(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);
    const formJson = Object.fromEntries(formData.entries());
    const spaceUid = String(formJson.spaceUid ?? "").trim();

    window.open("/share/space/" + spaceUid, "_blank");
  }

  return (
    <div className="h-screen bg-neutral-800 p-16 font-mono text-white">
      <h1 className="pb-8">Debug page</h1>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-6 xl:gap-8">
        <CardContainer heading="Mailbox">
          {mailboxes.map(({ name, vanityLink }) => (
            <PageLink
              key={vanityLink}
              label={name}
              to={`mailbox/${vanityLink}`}
            />
          ))}
        </CardContainer>

        <CardContainer heading="Team Mailbox">
          {teams.map(({ name, vanityLink }) => (
            <PageLink
              key={vanityLink}
              label={name}
              to={`mailbox/team/${vanityLink}`}
            />
          ))}
        </CardContainer>

        <CardContainer heading="Transfer">
          <form onSubmit={handleOpenTransfer}>
            <div className="flex flex-row items-stretch gap-2 ">
              <input
                type="text"
                name="transferId"
                placeholder="Transfer ID"
                className=" focus rounded bg-neutral-400/20 px-4 py-2 placeholder-white placeholder-opacity-80 outline-offset-2 focus:border focus:border-cyan-300 focus:placeholder-opacity-100 focus:outline-none focus:ring-0"
              ></input>

              <button
                type="submit"
                className="rounded bg-neutral-700 px-4 py-2 font-bold text-white hover:bg-neutral-600"
              >
                open
              </button>
            </div>
          </form>
        </CardContainer>

        <CardContainer heading="Drive file viewer">
          <form onSubmit={handleOpenDriveFileViewer}>
            <div className="flex flex-row items-stretch gap-2 ">
              <input
                type="text"
                name="shareLinkUid"
                placeholder="Share-link uid"
                className=" focus rounded bg-neutral-400/20 px-4 py-2 placeholder-white placeholder-opacity-80 outline-offset-2 focus:border focus:border-cyan-300 focus:placeholder-opacity-100 focus:outline-none focus:ring-0"
              ></input>

              <button
                type="submit"
                className="rounded bg-neutral-700 px-4 py-2 font-bold text-white hover:bg-neutral-600"
              >
                open
              </button>
            </div>
          </form>
        </CardContainer>

        <CardContainer heading="Published space">
          <form onSubmit={handleOpenPublishedSpace}>
            <div className="flex flex-row items-stretch gap-2 ">
              <input
                type="text"
                name="spaceUid"
                placeholder="Space uid"
                className=" focus rounded bg-neutral-400/20 px-4 py-2 placeholder-white placeholder-opacity-80 outline-offset-2 focus:border focus:border-cyan-300 focus:placeholder-opacity-100 focus:outline-none focus:ring-0"
              ></input>

              <button
                type="submit"
                className="rounded bg-neutral-700 px-4 py-2 font-bold text-white hover:bg-neutral-600"
              >
                open
              </button>
            </div>
          </form>
        </CardContainer>

        <CardContainer heading="Space invitation">
          <SpaceInvitationForm />
        </CardContainer>
      </div>
    </div>
  );
}

/** Extracts space uid + invitee from a pasted invitation URL, any path shape. */
function parseInvitationUrl(
  value: string
): { spaceUid: string; invitee: string } | undefined {
  const match = value.match(/invitation\/([^/?#]+)\/([^/?#]+)/);
  if (!match) return undefined;
  // The invitee segment may arrive raw or percent-encoded; decode defensively.
  const decode = (segment: string) => {
    try {
      return decodeURIComponent(segment);
    } catch {
      return segment;
    }
  };
  return { spaceUid: decode(match[1]), invitee: decode(match[2]) };
}

function SpaceInvitationForm() {
  const [spaceUid, setSpaceUid] = useState("");
  const [invitee, setInvitee] = useState("");

  // Pasting a whole invitation link into the uid field fills both fields.
  function handleSpaceUidChange(value: string): void {
    const parsed = parseInvitationUrl(value);
    if (parsed) {
      setSpaceUid(parsed.spaceUid);
      setInvitee(parsed.invitee);
    } else {
      setSpaceUid(value);
    }
  }

  function handleSubmit(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    window.open(
      "/invitation/" +
        spaceUid.trim() +
        "/" +
        encodeURIComponent(invitee.trim()),
      "_blank"
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col items-stretch gap-2">
        <input
          type="text"
          name="spaceUid"
          placeholder="Space uid or invitation URL"
          value={spaceUid}
          onChange={(event) => handleSpaceUidChange(event.target.value)}
          className=" focus rounded bg-neutral-400/20 px-4 py-2 placeholder-white placeholder-opacity-80 outline-offset-2 focus:border focus:border-cyan-300 focus:placeholder-opacity-100 focus:outline-none focus:ring-0"
        ></input>
        <input
          type="text"
          name="invitee"
          placeholder="Invitee e-mail"
          value={invitee}
          onChange={(event) => setInvitee(event.target.value)}
          className=" focus rounded bg-neutral-400/20 px-4 py-2 placeholder-white placeholder-opacity-80 outline-offset-2 focus:border focus:border-cyan-300 focus:placeholder-opacity-100 focus:outline-none focus:ring-0"
        ></input>

        <button
          type="submit"
          className="rounded bg-neutral-700 px-4 py-2 font-bold text-white hover:bg-neutral-600"
        >
          open
        </button>
      </div>
    </form>
  );
}

function CardContainer({
  heading,
  children,
}: {
  heading: string;
  children: React.ReactNode;
}) {
  return (
    <div className="items-end overflow-hidden rounded-lg border border-slate-600 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#03b4ad20] from-0% to-transparent to-70% p-4 transition-all hover:border-slate-500 hover:from-[#03b4ad30]">
      <h2 className="pb-4">{heading}</h2>
      {children}
    </div>
  );
}

function PageLink({ label, to }: { label: string; to: string }) {
  return (
    <Link
      to={to}
      className="group mx-1 flex items-center justify-between rounded-xl px-3 py-2 no-underline hover:bg-white hover:bg-opacity-10 hover:text-teal-400"
    >
      <h4 className="pt-1">{label}</h4>
      <FontAwesomeIcon
        icon={faArrowRight as IconProp}
        className="mr-2 transition-transform group-hover:translate-x-1"
      />
    </Link>
  );
}
